"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-three/sections/teamSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamSection346sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/team/team-img-1.png" | "/Templates/Doccure/img/team/team-img-2.png" | "/Templates/Doccure/img/team/team-img-3.png" | "/Templates/Doccure/img/team/team-img-4.png" */
    src: string;
    /** Detected variants: "08 Years Experience" | "12 Years Experience" | "05 Years Experience" | "15 Years Experience" */
    p0Text: ReactNode;
    /** Detected variants: "Dr. Sophia Nguyen" | "Dr. Lucas Evans" | "Dr. Ethan Brown" | "Dr. Emily Carter" */
    link0Text: ReactNode;
    /** Detected variants: "Pediatric Dentistry" | "General Dentistry" | "Braces & Aligners Specialist" | "Dental Implants" */
    p0P0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-lg-4 col-sm-6" */
    className?: string;
    /** Detected variants: "team-item-three" */
    div0ClassName?: string;
    /** Detected variants: "team-overley" */
    div0ClassName2?: string;
    /** Detected variants: "team-img-1" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "icons" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "isax isax-arrow-up-34" */
    i0ClassName?: string;
    /** Detected variants: "date" */
    p0ClassName?: string;
    /** Detected variants: "team-details" */
    div1ClassName?: string;
    /** Detected variants: "custom-title author-name" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    link0Href?: string;
    /** Detected variants: "author-dest" */
    p0ClassName2?: string;
};

type TeamSectionSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/hospital/hospital-img-1.png" | "/Templates/Doccure/img/hospital/hospital-img-2.png" | "/Templates/Doccure/img/hospital/hospital-img-3.png" | "/Templates/Doccure/img/hospital/hospital-img-4.png" | "/Templates/Doccure/img/hospital/hospital-img-5.png" | "/Templates/Doccure/img/hospital/hospital-img-6.png" */
    src: string;
    /** Detected variants: "slide-item" */
    className?: string;
    /** Detected variants: "hospital-img-1" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
    ],
};

export type HomeThreeTeamSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection346sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection346sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "fade-up" */
    sectionDiv0Div0DivDataAos?: string;
    /** Default: "Team Members" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Meet Our Expert Team" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Highly qualified, experienced dental professionals dedicated to your care" */
    sectionDiv0Div0P0PText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    sectionDiv0Div2Div0ClassName?: string;
    /** Default: "Worked with World's" */
    sectionDiv0Div2Div0Div0H40H4Text?: ReactNode;
    sectionDiv0Div2Div0Div0H40H4Visible?: boolean;
    sectionDiv0Div2Div0Div0H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2Div0Div0H40H4Props?: Partial<ComponentProps<"h4">>;
    /** Default: "Famous Hospitals & Doctors" */
    sectionDiv0Div2Div0Div0H40Span0SpanText?: ReactNode;
    sectionDiv0Div2Div0Div1Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    /** Default: "service-element-1" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/service-element-1.svg" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    teamSection346s: TeamSection346sItem[];
    teamSectionSlides: TeamSectionSlidesItem[];
    teamSection346sItemWrapper?: (item: TeamSection346sItem, content: ReactNode) => ReactNode;
    teamSection346sRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSection346sLinkVisible?: boolean;
    teamSection346sLinkRenderer?: (item: TeamSection346sItem, defaultNode: ReactNode) => ReactNode;
    teamSection346sImageVisible?: boolean;
    teamSection346sImageRenderer?: (item: TeamSection346sItem, defaultNode: ReactNode) => ReactNode;
    teamSection346sH3Visible?: boolean;
    teamSection346sH3Renderer?: (item: TeamSection346sItem, defaultNode: ReactNode) => ReactNode;
    teamSection346sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    teamSection346sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection346sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamSection346sH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection346sItem) => Partial<ComponentProps<"h3">>);
    teamSectionSlidesItemWrapper?: (item: TeamSectionSlidesItem, content: ReactNode) => ReactNode;
    teamSectionSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSectionSlidesImageVisible?: boolean;
    teamSectionSlidesImageRenderer?: (item: TeamSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    teamSectionSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeThreeTeamSectionGenerated: FC<HomeThreeTeamSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Team Members",
    sectionDiv0Div0DivDataAos = "fade-up",
    sectionDiv0Div0H20H2Text = "Meet Our Expert Team",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0P0PText = "Highly qualified, experienced dental professionals dedicated to your care",
    sectionDiv0Div2Div0Div0H40H4Text = "Worked with World's",
    sectionDiv0Div2Div0Div0H40H4Visible,
    sectionDiv0Div2Div0Div0H40H4Renderer,
    sectionDiv0Div2Div0Div0H40H4Props,
    sectionDiv0Div2Div0Div0H40Span0SpanText = "Famous Hospitals & Doctors",
    sectionImageWithBasePath0ImageAlt = "service-element-1",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/service-element-1.svg",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    divImageWithBasePath0ImageProps,
    sectionDiv0Div2Div0Div1Slider0SliderProps,
    sectionDiv0Div1ClassName,
    sectionDiv0Div2Div0ClassName,
    teamSection346s,
    teamSectionSlides,
    teamSection346sItemWrapper,
    teamSection346sRenderer,
    teamSection346sLinkVisible,
    teamSection346sLinkRenderer,
    teamSection346sImageVisible,
    teamSection346sImageRenderer,
    teamSection346sH3Visible,
    teamSection346sH3Renderer,
    teamSection346sLinkProps,
    teamSection346sImageProps,
    teamSection346sH3Props,
    teamSectionSlidesItemWrapper,
    teamSectionSlidesRenderer,
    teamSectionSlidesImageVisible,
    teamSectionSlidesImageRenderer,
    teamSectionSlidesImageProps,
}) => {
    return (
        <section className="team-section-three section">
            <div className="container">
                <div className="section-header section-header-three text-center aos" data-aos={sectionDiv0Div0DivDataAos}>
                    <div className="title">
                        <i className="fa-solid fa-circle" />
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    <p className="subtitle">{sectionDiv0Div0P0PText}</p>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row justify-content-center g-4"}>
                    {renderCollectionNode(
                        teamSection346s,
                        (item: TeamSection346sItem) => (
                            <div className={item.className ?? "col-xl-3 col-lg-4 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "team-item-three"}>
                                    <div className={item.div0ClassName2 ?? "team-overley"}>
                                        {renderItemNode(teamSection346sImageVisible, teamSection346sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "team-img-1"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof teamSection346sImageProps === "function" ? teamSection346sImageProps(item) : (teamSection346sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        <p className={item.p0ClassName ?? "date"}>{item.p0Text}</p>
                                        {renderItemNode(teamSection346sLinkVisible, teamSection346sLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "icons"} {...(typeof teamSection346sLinkProps === "function" ? teamSection346sLinkProps(item) : (teamSection346sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                <i className={item.i0ClassName ?? "isax isax-arrow-up-34"} />
                                            </SmartLink>
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "team-details"}>
                                        {renderItemNode(teamSection346sH3Visible, teamSection346sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title author-name"} {...(typeof teamSection346sH3Props === "function" ? teamSection346sH3Props(item) : (teamSection346sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(teamSection346sLinkVisible, teamSection346sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "#"} {...(typeof teamSection346sLinkProps === "function" ? teamSection346sLinkProps(item) : (teamSection346sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p className={item.p0ClassName2 ?? "author-dest"}>{item.p0P0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        teamSection346sItemWrapper,
                        teamSection346sRenderer
                    )}
                </div>
                <div className="partner-item-three">
                    <div className={sectionDiv0Div2Div0ClassName ?? "row align-items-center justify-content-center justify-content-xxl-start g-4"}>
                        <div className="col-xl-4">
                            {renderNode(sectionDiv0Div2Div0Div0H40H4Visible, sectionDiv0Div2Div0Div0H40H4Renderer, (
                                <h4 className="title" {...(sectionDiv0Div2Div0Div0H40H4Props ?? {})}>
                                    {sectionDiv0Div2Div0Div0H40H4Text}
                                    {" "}
                                    <span className="d-block">{sectionDiv0Div2Div0Div0H40Span0SpanText}</span>
                                </h4>
                            ))}
                        </div>
                        <div className="col-xl-8">
                            <Slider {...settings} className="hospital-img hospital-slider-four" {...(sectionDiv0Div2Div0Div1Slider0SliderProps ?? {})}>
                                {renderCollectionNode(
                                    teamSectionSlides,
                                    (item: TeamSectionSlidesItem) => (
                                        <div className={item.className ?? "slide-item"} key={item.key}>
                                            {renderItemNode(teamSectionSlidesImageVisible, teamSectionSlidesImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "hospital-img-1"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof teamSectionSlidesImageProps === "function" ? teamSectionSlidesImageProps(item) : (teamSectionSlidesImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                    ),
                                    teamSectionSlidesItemWrapper,
                                    teamSectionSlidesRenderer
                                )}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeThreeTeamSectionGenerated;
